import PropTypes from 'prop-types';
import { Grid, Typography, makeStyles } from '@material-ui/core';
import FormikSelectField from '../../../FormikFields/FormikSelectField';
import FormikMultiSelectField from '../../../FormikFields/FormikMultiSelectField';
import {
  scitItems,
  deprecatedScitItems,
  allergenItems,
  allergySymptoms,
  symptomsExposure,
  symptomsTimeOfYear,
  symptomsTimeInDay,
  symptomsMostlyOccur,
  allergyDiagnosis,
  examinationReveals,
} from '../../constants';
import { useSelector } from 'react-redux';

const useStyles = makeStyles((theme) => ({
  fullWidth: {
    width: '100%',
    maxWidth: 'none',
    marginTop: 0,
  },
  additionalFields: {
    marginTop: theme.spacing(3),
    padding: theme.spacing(3),
    backgroundColor: '#fafafa',
    borderRadius: 8,
    border: '1px solid #e0e0e0',
  },
  subGroupTitle: {
    fontSize: '0.95rem',
    fontWeight: 600,
    color: theme.colors?.blue2 || '#122056',
    marginBottom: theme.spacing(2),
  },
}));

const SCITDetails = ({
  values,
  backendErrors,
  isEditable,
  canEnableImmunotherapyReport,
}) => {
  const classes = useStyles();
  const { en: { forms, allergens } } = useSelector((state) => state.i18n);

  return (
    <>
      <Grid container spacing={3}>
        <Grid item xs={12} md={6}>
          <FormikSelectField
            name='scitType'
            label={forms.orderType}
            type='text'
            menuItems={
              values.scitType === deprecatedScitItems[0].value
                ? [deprecatedScitItems[0], ...scitItems]
                : scitItems
            }
            required
            backendError={backendErrors.scitType}
            className={classes.fullWidth}
            disabled={!isEditable}
            hideErrorAreaIfNoErrors
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <FormikMultiSelectField
            name='scitAllergens'
            type='text'
            items={allergenItems}
            label={forms.allergens}
            labelWidth={78}
            required
            backendError={backendErrors.scitAllergens}
            className={classes.fullWidth}
            disabled={!isEditable}
            hideErrorAreaIfNoErrors
          />
        </Grid>
      </Grid>
      {canEnableImmunotherapyReport && (
        <div className={classes.additionalFields}>
          <Typography className={classes.subGroupTitle}>
            Additional Clinical Information
          </Typography>
          <Grid container spacing={3}>
            <Grid item xs={12} md={6}>
              <FormikMultiSelectField
                name='allergySymptoms'
                type='text'
                items={allergySymptoms}
                label={allergens.allergySymptoms}
                labelWidth={78}
                required
                backendError={backendErrors.allergySymptoms}
                className={classes.fullWidth}
                disabled={!isEditable}
                hideErrorAreaIfNoErrors
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <FormikMultiSelectField
                name='symptomsExposure'
                type='text'
                items={symptomsExposure}
                label={allergens.symptomsExposure}
                labelWidth={78}
                required
                backendError={backendErrors.symptomsExposure}
                className={classes.fullWidth}
                disabled={!isEditable}
                hideErrorAreaIfNoErrors
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <FormikMultiSelectField
                name='symptomsTimeOfYear'
                type='text'
                items={symptomsTimeOfYear}
                label={allergens.symptomsTimeOfYear}
                labelWidth={78}
                required
                backendError={backendErrors.symptomsTimeOfYear}
                className={classes.fullWidth}
                disabled={!isEditable}
                hideErrorAreaIfNoErrors
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <FormikSelectField
                name='symptomsTimeInDay'
                type='text'
                menuItems={symptomsTimeInDay}
                label={allergens.symptomsTimeInDay}
                labelWidth={78}
                required
                backendError={backendErrors.symptomsTimeInDay}
                className={classes.fullWidth}
                disabled={!isEditable}
                hideErrorAreaIfNoErrors
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <FormikSelectField
                name='symptomsMostlyOccur'
                type='text'
                menuItems={symptomsMostlyOccur}
                label={allergens.symptomsMostlyOccur}
                labelWidth={78}
                required
                backendError={backendErrors.symptomsMostlyOccur}
                className={classes.fullWidth}
                disabled={!isEditable}
                hideErrorAreaIfNoErrors
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <FormikMultiSelectField
                name='examinationReveals'
                type='text'
                items={examinationReveals}
                label={allergens.examinationReveals}
                labelWidth={78}
                required
                backendError={backendErrors.examinationReveals}
                className={classes.fullWidth}
                disabled={!isEditable}
                hideErrorAreaIfNoErrors
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <FormikMultiSelectField
                name='allergyDiagnosis'
                type='text'
                items={allergyDiagnosis}
                label={allergens.allergyDiagnosis}
                labelWidth={78}
                required
                backendError={backendErrors.allergyDiagnosis}
                className={classes.fullWidth}
                disabled={!isEditable}
                hideErrorAreaIfNoErrors
              />
            </Grid>
          </Grid>
        </div>
      )}
    </>
  );
};

SCITDetails.propTypes = {
  values: PropTypes.shape({
    scitType: PropTypes.string,
  }).isRequired,
  backendErrors: PropTypes.shape({
    scitType: PropTypes.string,
    scitAllergens: PropTypes.string,
    allergySymptoms: PropTypes.string,
    symptomsExposure: PropTypes.string,
    symptomsTimeOfYear: PropTypes.string,
    symptomsTimeInDay: PropTypes.string,
    symptomsMostlyOccur: PropTypes.string,
    examinationReveals: PropTypes.string,
    allergyDiagnosis: PropTypes.string,
  }),
  isEditable: PropTypes.bool,
  canEnableImmunotherapyReport: PropTypes.bool,
};

SCITDetails.defaultProps = {
  backendErrors: {},
  isEditable: true,
  canEnableImmunotherapyReport: false,
};

export default SCITDetails;
